var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-screen",class:_vm.theme},_vm._l((_vm.rows),function(item,index){return _c('div',{key:index,staticClass:"ss-item",class:`ss-item-${index}`,style:(_vm.combinedStyle)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }